import React from 'react';
import useStyles from "./styles";
import PropTypes from "prop-types";

const StatusProgress = ({ listStatus, currentStatus, ...props }) => {
    
    let progressIndex = 0;
    listStatus.forEach((status, index) => {
        if (status.completed) {
            progressIndex = index;
        }
    });

    const classes = useStyles();
    const progress = `${((progressIndex + 1) / listStatus.length) * 100}%`;

    const MarkProgress = ({ title, hour, completed, notShow }) => (
        <div className={`${classes.markProgress} ${completed ? 'completed' : ''} ${notShow ? 'notShow' : ''}`}>
            <small>{hour}</small>
            <p>{title}</p>
            <span />
        </div>
    );

    return <div {...props}>
        <div className={classes.progressMarkContainer}>
            {listStatus.map((status, index) => (
                <MarkProgress key={index} title={status.title} hour={status.subtitle} completed={status.completed} notShow={status.notShow}/>
            ))}
        </div>
        <div className={classes.progressContainer}>
            <div className={classes.progressContent} style={{ width: progress }}></div>
        </div>
    </div>
};

StatusProgress.propTypes = {
    listStatus: PropTypes.array.isRequired,
    currentStatus: PropTypes.string.isRequired,
};

export default StatusProgress;